import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Duolingo-style section header: small uppercase eyebrow ("SEÇÃO 1 · UNIDADE 1")
 * over a larger unit title.
 */
export function SectionHeader({ eyebrow, title, trailing }) {
    return (_jsxs("header", { className: "sl-section-header", children: [_jsxs("div", { className: "sl-section-header__text", children: [eyebrow ? _jsx("span", { className: "sl-section-header__eyebrow", children: eyebrow }) : null, _jsx("h2", { className: "sl-section-header__title", children: title })] }), trailing ? _jsx("div", { className: "sl-section-header__trailing", children: trailing }) : null] }));
}
//# sourceMappingURL=SectionHeader.js.map